import { ChartConfig } from "./chart-container";

export namespace ChartMentalBalance {
  export type Domain =
    | "selfcontrol"
    | "physicalcondition"
    | "confidence"
    | "performance"
    | "balance"
    | "relationships"
    | "stressresistance"
    | "lustforlife";

  export interface Sector {
    domain: Domain;
    slice: number;
    fill: string;
    midAngle?: number;
    labelOffset?: number;
    dashedConnector?: boolean;
  }

  export const outerSectors: Sector[] = [
    {
      domain: "selfcontrol",
      slice: 100,
      fill: "hsla(0, 0%, 0%, 0)",
      midAngle: 15,
      labelOffset: 200,
    },
    {
      domain: "physicalcondition",
      slice: 100,
      fill: "hsla(0, 0%, 0%, 0)",
      midAngle: 60,
    },
    {
      domain: "confidence",
      slice: 100,
      fill: "hsla(0, 0%, 0%, 0)",
      midAngle: 120,
    },
    {
      domain: "performance",
      slice: 100,
      fill: "hsla(0, 0%, 0%, 0)",
      midAngle: 160,
    },
    {
      domain: "balance",
      slice: 100,
      fill: "hsla(0, 0%, 0%, 0)",
      midAngle: 205,
    },
    {
      domain: "relationships",
      slice: 100,
      fill: "hsla(0, 0%, 0%, 0)",
      midAngle: 260,
    },
    {
      domain: "stressresistance",
      slice: 100,
      fill: "hsla(0, 0%, 0%, 0)",
      midAngle: 295,
      labelOffset: 145,
    },
    {
      domain: "lustforlife",
      slice: 100,
      fill: "hsla(0, 0%, 0%, 0)",
      midAngle: 330,
      labelOffset: 80,
    },
  ];

  export const innerSectors: Sector[] = [
    {
      domain: "selfcontrol",
      slice: 100,
      fill: "rgba(70, 183, 155, 0.85)",
      dashedConnector: true,
    },
    {
      domain: "physicalcondition",
      slice: 100,
      fill: "rgba(70, 183, 155, 0.85)",
    },
    {
      domain: "confidence",
      slice: 100,
      fill: "rgba(170, 79, 203, 0.58)",
      dashedConnector: true,
    },
    {
      domain: "performance",
      slice: 100,
      fill: "rgba(170, 79, 203, 0.58)",
    },
    {
      domain: "balance",
      slice: 100,
      fill: "rgba(61, 134, 224, 0.85)",
      dashedConnector: true,
    },
    {
      domain: "relationships",
      slice: 100,
      fill: "rgba(61, 134, 224, 0.85)",
    },
    {
      domain: "stressresistance",
      slice: 100,
      fill: "rgba(249, 112, 154, 0.85)",

      dashedConnector: true,
    },
    {
      domain: "lustforlife",
      slice: 100,
      fill: "rgba(249, 112, 154, 0.85)",
    },
  ];

  export type Config = {
    [P in Domain]: ChartConfig[P] & { tag: string };
  };

  export const config: Config = {
    selfcontrol: {
      label: "Самоконтроль",
      color: "#4EBCA0",
      tag: "Тіло",
    },
    physicalcondition: {
      label: "Фізичний стан",
      color: "#4EBCA0",
      tag: "Тіло",
    },
    confidence: {
      label: "Спокій",
      color: "#AA4FCB",
      tag: "Діяльність",
    },
    performance: {
      label: "Продуктивність",
      color: "#AA4FCB",
      tag: "Діяльність",
    },
    balance: {
      label: "Врівноваженість",
      color: "#3D86E0",
      tag: "Оточення",
    },
    relationships: {
      label: "Стосунки",
      color: "#3D86E0",
      tag: "Оточення",
    },
    stressresistance: {
      label: "Cтресостійкість",
      color: "#F9709A",
      tag: "Усвідомленість",
    },
    lustforlife: {
      label: "Жага до життя",
      color: "#F9709A",
      tag: "Усвідомленість",
    },
  };
}
